/**
Author - Pradip Dhakal
Git - https://github.com/pradipwealthy
**/

import EuinCardUpload from "./EuinCardUpload.container";

export default EuinCardUpload;